export const DEFAULT_CATEGORY = "All";
export const DEFAULT_LIST_TYPE = "default";
export const LIST_CREATE_REQUEST_UNSTARTED = "LIST_CREATE_REQUEST_UNSTARTED";
export const LIST_CREATE_REQUEST_STARTED = "LIST_CREATE_REQUEST_STARTED";
export const LIST_CREATE_REQUEST_SUCCESS = "LIST_CREATE_REQUEST_SUCCESS";
export const LIST_CREATE_REQUEST_FAILURE = "LIST_CREATE_REQUEST_FAILURE";
